import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React, { useState }  from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddEnrollmentMutation,useGetQualificationListQuery,useGetStudentListQuery,useGetMainCourseQuery,useGetLicenseExpiryListQuery,useGetCourseListQuery} from "../../Services/api";
import { MultiSelect } from "react-multi-select-component";

export default function AddEnroll() {
    const validationSchema = Yup.object().shape({
        student_id: Yup.string().required("student fields is required"),
        description: Yup.string().required("description fields is required"),
        activity: Yup.string().required("course fields is required"),
        licenseExpiryId: Yup.string().required("license expiry fields is required"),
        start_date: Yup.string().required("start date fields is required"),
        end_date: Yup.string().required("end date fields is required"),
    });
    let defaultValues = { name: ""};
    const notify = () => '';
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues,
    });
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = methods;
    const [addEnrollment,isLoading] = useAddEnrollmentMutation();
    const onSubmit = (values,e) => {
   
            addEnrollment({ data: values })
            .unwrap()
            .then((payload) => {
                if (payload.status) {
                    e.target.reset()
                    toast.success(payload.message)
                } else {
                    toast.error(payload.message)
                }
            })
            .catch((error) => {
                toast.error(error.data.message)
            });
            notify();
    };
    const { 
        data: StudentList        
    } = useGetStudentListQuery();
    const { 
        data: MainCourse        
    } = useGetMainCourseQuery();
    const { 
        data: LicenseExpiryList        
    } = useGetLicenseExpiryListQuery();
    const [mainCourse,setMainCourse]= useState(0);
    const findMainCourse=(e)=>{
     
        setMainCourse(e.target.value);
    }
    const { 
        data: getQualificationList        
    } = useGetQualificationListQuery({  params:''});
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:mainCourse});
    
    const [studentId, setStudentId] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const nameToHandler = (value) => {
        setValue("student_id", value[0]?.value);
        setStudentId([...value])
    }
    const findDate=(e)=>{
        const currentDate = new Date();
        const today = currentDate.toISOString().split('T')[0]
        if(e==1){
            currentDate.setMonth(currentDate.getMonth() + 1);
        }
        else if(e==2){
            currentDate.setMonth(currentDate.getMonth() + 3);
        }
        else if(e==3){
            currentDate.setMonth(currentDate.getMonth() + 6);
        }
        else if(e==4){
            currentDate.setMonth(currentDate.getMonth() + 12);
        }
        const formattedDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        setStartDate(today);
        setEndDate(formattedDate);
        setValue("start_date",today);
        setValue("end_date",formattedDate);
    }
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Enroll Student</h5>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">student</label>
                            <div className="col-sm-10">
                            <MultiSelect
                                options={typeof (StudentList?.data) == "undefined" ? [] : StudentList?.data?.map(({ student_id,first_name,last_name,email }) => {
                                        return {
                                            label: `${first_name} ${last_name} ( ${email} )`,
                                            value: student_id
                                        }
                                    })
                                }
                                value={studentId}
                                onChange={nameToHandler}
                                labelledBy="Select"
                            />
                               
                                <span className="text-danger">{errors.student_id?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Description </label>
                            <div className="col-sm-10">
                                <select  {...register("description")} className="form-control" onChange={findMainCourse}>
                                 <option value="">Select description</option>                                           
                                  {                            
                                       getQualificationList?.data?.map((item) => {
                                        return (
                                            <option key={item.qid} value={item.qid}>{item.qualification}</option>                                           
                                            )
                                        })
                                   }
                                </select>
                                <span className="text-danger">{errors.description?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                            <div className="col-sm-10">
                                <select  {...register("activity")} className="form-control" >
                                 <option value="">Select activity</option>                                           

                                {                            
                                    getCourseList?.data?.map((item) => {
                                    return (
                                        <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                <span className="text-danger">{errors.activity?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">License Validity</label>
                            <div className="col-sm-10">
                                <select  {...register("licenseExpiryId")} className="form-control" onChange={(e)=>findDate(e.target.value)}>
                                 <option value="">Select License Validity</option>                                           
                                {                            
                                  LicenseExpiryList?.data?.map((item) => {
                                    return (
                                        <option key={item.id} value={item.id}>{item.validity}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                <span className="text-danger">{errors.licenseExpiryId?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Start Date</label>
                            <div className="col-sm-10">
                                  <input type="date"   value={startDate} className="form-control" />
                                
                                <span className="text-danger">{errors.start_date?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">End Date</label>
                            <div className="col-sm-10">
                               <input type="date"   value={endDate} className="form-control" />
                                <span className="text-danger">{errors.end_date?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label"></label>
                            <div className="col-sm-10">
                                {isLoading.status !='pending' ? 
                                                
                                                <button type="submit" className="btn btn-warning w-100" >Enroll Student</button>
                                                :
                                                <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </section>
        </div>
    );
}